module.exports = __webpack_public_path__ + "img/omsdk.a7e8da25.png";